export default function ({ $auth, redirect }) {
  if (!$auth.loggedIn) {
    return redirect('/login')
  }
  if (!['admin', 'editor'].includes($auth.user.role)) {
    return redirect('/')
  }
}
